import React from 'react';
import { connect } from 'react-redux';

import AutoSuggesterInput from 'src/app/components/AutoSuggesterInput';
import {
  countryBlur,
  countryChange,
  countryFocus,
  countrySetId,
  countrySuggestionsGet
} from 'src/app/redux/actions/registration/experience/experienceCountry';


class ExperienceCountry extends React.Component {

  state = {
    renderedSuggestions: []
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(countrySuggestionsGet());
  }

  renderSuggestion = ({ value }) => (<p data-test="text-country-suggestion">{ value }</p>);

  clearSuggestions = () => {
    this.setState({ renderedSuggestions: [] });
  };

  getSuggestions = ({ value }) => {
    const { suggestions } = this.props;

    this.setState(
      {
        renderedSuggestions: suggestions
          .filter(suggestion => suggestion.value.toLowerCase().includes(value.toLowerCase()))
          .slice(0, 5)
      }
    );
  };

  onSuggestionSelected = (event, { suggestion }) => {
    const { dispatch } = this.props;
    const { id } = suggestion;

    dispatch(countrySetId(id));
  };

  onChange = ({ target }, { newValue }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { validationMessage } = target;

    dispatch(countryChange({
      value: newValue,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(countryFocus());
  };

  onBlur = ({ highlightedSuggestion }) => {
    const { dispatch, suggestions, value, inputRef } = this.props;
    const { validationMessage } = inputRef.current;

    dispatch(countryBlur({ value, suggestions, validationMessage, highlightedSuggestion }));
  };


  render() {
    const {
      onChange,
      onBlur,
      onFocus,
      getSuggestions,
      clearSuggestions,
      renderSuggestion,
      onSuggestionSelected,
      state
    } = this;
    const { value, validationMessage, focus, markedAsWrong, apiError, inputRef, sending } = this.props;

    return (
      <AutoSuggesterInput id="country"
                          label="Kraj"
                          required
                          inputRef={ inputRef }
                          disabled={ sending }
                          getSuggestionValue={ (suggestion) => suggestion.value }
                          suggestions={ state.renderedSuggestions }
                          dataTest="input-country"
                          { ...{
                            value,
                            validationMessage,
                            focus,
                            markedAsWrong,
                            apiError,
                            onSuggestionSelected,
                            renderSuggestion,
                            onChange,
                            onBlur,
                            onFocus,
                            getSuggestions,
                            clearSuggestions
                          }
                          }
      />
    );
  }
}

const mapStateToProps = (store) => ({
  ...store.experienceCountryReducer,
  ...store.experienceFormReducer
});

export default connect(mapStateToProps)(ExperienceCountry);
